export default {
  positiveNumber: number => number !== '' && +number >= 0
}
